import { useToast } from '@chakra-ui/react'

export enum LabSchedulingErrorCode {
  NO_LOCATIONS = 'NO_LOCATIONS',
  NO_TIMESLOTS = 'NO_TIMESLOTS',
  NOT_FOUND = 'NOT_FOUND',
  NO_LONGER_AVAILABLE = 'NO_LONGER_AVAILABLE',
  USER_ERROR = 'USER_ERROR',
  GENERIC_ERROR = 'GENERIC_ERROR',
  DATE_TOO_FAR = 'DATE_TOO_FAR',
}

export interface LabSchedulingError {
  message: string
  code: LabSchedulingErrorCode
}

export function useLabSchedulingError() {
  const toast = useToast()

  // Some errors are "critical" and handled in the TimeSlotMap component
  // Others are just toast here
  const handleLabSchedulingError = (
    error: unknown,
    fallbackMessage: string
  ) => {
    if (error && typeof error === 'object' && 'response' in error) {
      const response = (error as any).response

      if (response?.data) {
        const apiError = response.data as LabSchedulingError

        switch (apiError.code) {
          case LabSchedulingErrorCode.NO_LOCATIONS:
          case LabSchedulingErrorCode.NO_TIMESLOTS:
          case LabSchedulingErrorCode.DATE_TOO_FAR:
            break
          case LabSchedulingErrorCode.NOT_FOUND:
            toast({
              title: 'Error',
              description: 'Appointment was not found. Please try again later.',
              status: 'error',
              duration: 30000,
              isClosable: true,
            })
            break
          case LabSchedulingErrorCode.NO_LONGER_AVAILABLE:
            toast({
              title: 'Error',
              description:
                'Appointment slot is no longer available. Please choose a different time.',
              status: 'error',
              duration: 30000,
              isClosable: true,
            })
            break
          case LabSchedulingErrorCode.USER_ERROR:
            toast({
              title: 'Error',
              description: apiError.message,
              status: 'error',
              duration: 5000,
              isClosable: true,
            })
            break
          case LabSchedulingErrorCode.GENERIC_ERROR:
            toast({
              title: 'Error',
              description: apiError.message,
              status: 'error',
              duration: 30000,
              isClosable: true,
            })
            break
          default:
            toast({
              title: 'Error',
              description: apiError.message,
              status: 'error',
              duration: 30000,
              isClosable: true,
            })
        }

        return apiError
      }
    }

    toast({
      title: 'Error',
      description: fallbackMessage,
      status: 'error',
      duration: 30000,
      isClosable: true,
    })

    return null
  }

  return { handleLabSchedulingError }
}
